'use client';

import fork from '@haaretz/l-fork.macro';
import mq from '@haaretz/l-mq.macro';
import space from '@haaretz/l-space.macro';
import HtzImage from '@haaretz/s-htz-image';
import parseFullImageSrc from '@haaretz/s-image-utils/parseFullImageSrc';
import s9 from 'style9';

import type { ImageFragment } from '@haaretz/s-fragments/HTZ_image_Image';
import type { HtzImageProps } from '@haaretz/s-htz-image';
const c = s9.create({
  successImg: {
    width: space(fork({ default: 37.5, hdc: 50 })),

    ...mq({
      from: 'l',
      value: {
        width: space(50),
      },
    }),
  },
  errorImg: {
    width: space(37.5),

    ...mq({
      from: 'l',
      value: {
        width: space(50),
      },
    }),
  },
});

const successImgDataProd = parseFullImageSrc(
  fork({
    default:
      'https://img.haarets.co.il/bs/00000195-3874-de7d-ad9d-bd7cb2f70001/58/85/8e06c7d6480c91e38b56d8476092/htz-success.png',
    tm: 'https://img.haarets.co.il/bs/00000195-387c-db57-abbf-7b7f93d40001/e8/54/2b158cdb4e03a5f5ba871443da71/tm-success.png',
    hdc: 'https://img.haarets.co.il/bs/00000195-3878-d3be-a3ff-3b7ad2450001/ce/d0/a90a11a242e8b0f7c0a705dbc1da/hdc-success.png',
  })
);

const errorImgDataProd = parseFullImageSrc(
  fork({
    default:
      'https://img.haarets.co.il/bs/00000195-3876-d56d-a7ff-387efa2b0001/11/4c/813b3a80403b9fc743605461b36f/htz-error.png',
    tm: 'https://img.haarets.co.il/bs/00000195-3878-d6e8-a3d7-fdfd41d40001/e7/5e/545358e5492eb45047a3d4d56f0a/tm-error.png',
    hdc: 'https://img.haarets.co.il/bs/00000195-387a-d3be-a3ff-3b7ad4910001/08/ca/8757f35d4bb18bb3a53641b8fa6e/hdc-error.png',
  })
);

export function SuccessImage() {
  if (!successImgDataProd) return null;

  const imgData: ImageFragment['files'][number] = {
    __typename: 'ImageViewModel_ImageFile',
    crops: { __typename: 'ImageCrops' },
    width: 400,
    height: fork({ default: 300, tm: 449 }),
    path: successImgDataProd.path,
  };

  const contentId = successImgDataProd.contentId;

  const imgProps: HtzImageProps = {
    imgData,
    type: 'image',
    alt: 'alt',
    contentId,
    widths: [...fork({ default: [150], hdc: [] }), 200, 225],
    aspect: 'full',
    sizes: [{ from: 's', size: '200px' }, { size: fork({ default: '150px', hdc: '200px' }) }],
  };

  return <HtzImage {...imgProps} styleExtend={[c.successImg]} envOverride="prod" />;
}

export function ErrorImage() {
  if (!errorImgDataProd) return null;

  const imgData: ImageFragment['files'][number] = {
    __typename: 'ImageViewModel_ImageFile',
    crops: { __typename: 'ImageCrops' },
    width: 400,
    height: fork({ default: 300, tm: 231, hdc: 324 }),
    path: errorImgDataProd.path,
  };

  const contentId = errorImgDataProd.contentId;

  const imgProps: HtzImageProps = {
    imgData,
    type: 'image',
    alt: 'alt',
    contentId,
    widths: [150, 200, 225],
    aspect: 'full',
    sizes: [{ from: 's', size: '200px' }, { size: '150px' }],
  };

  return <HtzImage {...imgProps} styleExtend={[c.errorImg]} envOverride="prod" />;
}
